(ns frontend.view.components.bar-chart
  (:require
   [frontend.utils :as fu]))

(defn options
  [{:keys [grid-line-color background-color label-color labels-color legend label y-title y-labels
           series-color height width type tick-interval]} items]
  {:chart       {:type            (or type "column")
                 :backgroundColor background-color
                 :borderRadius    10
                 :height          height
                 :width           width}
   :title       {:text  (or label nil)
                 :style (merge {:fontSize   "14px"
                                :fontFamily "Colibri, Agenda, sans-serif"}
                               (when label-color
                                 {:color (fu/sanitize-color label-color)}))}
   :xAxis       [{:categories      (map :label items)
                  :lineWidth       0
                  :minorTickLength 0
                  :tickLength      0
                  :labels          {:useHTML false
                                    :style   {:color (fu/sanitize-color labels-color)}}}]
   :yAxis       {:maxPadding      0
                 :lineWidth       0
                 :minorTickLength 0
                 :tickLength      0
                 :tickInterval    (or tick-interval 2)
                 :gridLineColor   grid-line-color
                 :labels          {:enabled (or y-labels)}
                 :title           {:enabled (boolean y-title)
                                   :text    y-title}}
   :series      [{:data      (map :count items)
                  :animation false}]
   :plotOptions {:series {:stacking    "normal"
                          :color       series-color
                          :borderWidth 0}
                 :column {:dataLabels {:enabled       true
                                       ;:style         {:textOutline 0}
                                       :borderWidth   0
                                       :verticalAlign "top"}}}
   :tooltip     {:enabled false}
   :credits     {:enabled false}
   :legend      {:enabled (or legend)}})
